import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { makeGetWishlistCounter } from '../../../redux/wishList/selectors/WishListSelectors';
export const NavigationWishlistBadge = () => {
    const wishlistCount = useSelector(makeGetWishlistCounter());
    if (!wishlistCount) {
        return null;
    }
    return (_jsx(Badge, { size: "sm", color: "branded", children: wishlistCount }));
};
